import type { IconNode } from '../types';

/**
 * @name siren-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJ2NiIgLz4KICA8cGF0aCBkPSJNMTIgMnYxIiAvPgogIDxwYXRoIGQ9Ik0xMi43MDcgNy4wNWE1IDUgMCAwIDEgNC4yNDMgNC4yNDMiIC8+CiAgPHBhdGggZD0iTTE3IDE3djFIN2EyIDIgMCAwIDAtMiAydjFhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xdi0xYTIgMiAwIDAgMC0yLTIiIC8+CiAgPHBhdGggZD0iTTE4LjUgNC41IDE4IDUiIC8+CiAgPHBhdGggZD0iTTIgMTJoMSIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik0yMSAxMmgxIiAvPgogIDxwYXRoIGQ9Ik03IDE4di02YTUgNSAwIDAgMSAxLjQ2NC0zLjUzNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/siren-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SirenOff: IconNode = [
  ['path', { d: 'M12 12v6' }],
  ['path', { d: 'M12 2v1' }],
  ['path', { d: 'M12.707 7.05a5 5 0 0 1 4.243 4.243' }],
  ['path', { d: 'M17 17v1H7a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2' }],
  ['path', { d: 'M18.5 4.5 18 5' }],
  ['path', { d: 'M2 12h1' }],
  ['path', { d: 'm2 2 20 20' }],
  ['path', { d: 'M21 12h1' }],
  ['path', { d: 'M7 18v-6a5 5 0 0 1 1.464-3.536' }],
];

export default SirenOff;
